import defaultLayout from './../../../layouts/default/default.vue'
import hofService from './../../../services/hof'
import store from './../../../store'
import {keys, orderBy} from 'lodash'
import Vue from 'vue'

export default {
  components: {
    VLayout: defaultLayout,
  },

  data () {
    return {
      decade: this.$route.params.decade,
    }
  },

  created () {
    store.dispatch('setPage', {title: 'Hall of Fame'})
    hofService.find()
  },

  computed: {
    hofDecade () {
      return store.state.hof.all[this.decade] || []
    },
    teamList () {
      return orderBy(this.hofDecade.teams, 'years')
    },
    athleteList () {
      return orderBy(this.hofDecade.athletes, 'fullName')
    },
    decadeList () {
      return keys(store.state.hof.all).slice(0, -2)
    },
    nextDisabled () {
      return this.decade === this.decadeList[this.decadeList.length - 1]
    },
    previousDisabled () {
      return this.decade === this.decadeList[0]
    },
  },

  methods: {
    previousDecade () {
      if (!this.previousDisabled) {
        this.decade = String(+this.decade - 10)
      }
    },
    nextDecade () {
      if (!this.nextDisabled) {
        this.decade = String(+this.decade + 10)
      }
    },
    changeDecade (event) {
      const decade = event.target.value
      Vue.router.replace({name: 'hof.index', params: {decade}})
    },
  },
}
